var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeusMenus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 24.113,
    viewBox: "0 0 31 24.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(-20 -219.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_132",
    "data-name": "Uni\\xE3o 132",
    d: "M11.982,5.008q0-.1-.005-.2,0,.1-.005.2V18.823a8.4,8.4,0,0,0-3.592-.866H0V0H7.183C11-.019,11.9,1.1,11.977,3.918,12.052,1.1,12.958-.019,16.77,0h7.183V17.957h-8.38a8.406,8.406,0,0,0-3.592.866Z",
    transform: "translate(26.047 220.271)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_375",
    "data-name": "Caminho 375",
    d: "M5.835,13.837,4,13.145V29.908c0,1.751.755,2.491,2.54,2.491H21.687l-.706-1.8H5.835Z",
    transform: "translate(16 210.985)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_376",
    "data-name": "Caminho 376",
    d: "M15.182,11.473h6.313v1.211H15.182Zm0,2.321h3.156v1.211H15.182Zm0-4.643h6.313v1.211H15.182Z",
    transform: "translate(13.662 217.604)",
    fill: "#f8f9fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeusMenus);
export default __webpack_public_path__ + "static/media/meus-menus.30164b41f6dea29a4d16acb464b0b344.svg";
export { ForwardRef as ReactComponent };